module.exports = __webpack_public_path__ + "static/media/PRIJATELJI_SV_MARTINA_2.bc10812e.png";